export const PAGE_TITLE_SIZE = 3;
export const TAB_POSITION = 'top';
export const CURRENCY = 'AUD';
